import AppleLogo from '../../assets/images/ios_app_store.svg'
import React from "react";
import PlayLogo from "../../assets/images/google-play-badge.png"

const Mobile = () => {
    return (
        <section className="page page-session">
            <div className="session-wrap">
                <div className="session-left mobile">
                    <div className="left-data-container">
                        <h2 className="normal" style={{textAlign: 'center'}}>Apps now available for iOS and Android!</h2>
                        <a href="https://apps.apple.com/us/app/medi-weightloss-spw/id1494777401">
                            <img className="text-center w-100" style={{padding: '10px'}} alt='Get it on the App Store' src={AppleLogo}/>
                        </a>
                        <a href='https://play.google.com/store/apps/details?id=com.spw'>
                            <img className="text-center w-100" style={{padding: '10px'}} alt='Get it on Google Play' src={PlayLogo}/>
                        </a>
                        <p>Access is FREE for active Medi-Weightloss® patients and includes:</p>
                        <ul className="check-list">
                            <li>Your weight statistics and progress</li>
                            <li>Food and supplement journal</li>
                            <li>Exercise plans and tracker </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Mobile;
